import type { FC } from 'react';
import { Box, Grid, useDeviceType, ErrorBoundary } from '@packages/shared';
import type { CmsData } from '@packages/cms-components/interfaces';
import { ContentExternal } from '@packages/cms-components';
import type {
  SearchSeoApiResponse,
  Brand,
  BrandHeadline,
  CategoryNavigationItem,
} from '../../api/rest/types';
import { BrandList } from '../BrandList';
import { ProductListSeo } from '../ProductListSeo';
import { ProductCategoryNavigationDesktop } from '../ProductCategoryNavigationDesktop';

export type CategoryPageBrandOverviewProps = {
  cmsContent?: CmsData | null;
  seoResponse?: SearchSeoApiResponse | null;
  categoryNavigation?: CategoryNavigationItem[];
  brands: Brand[];
  brandHeadlines: BrandHeadline[];
};

/**
 * Page content for Brands page
 * */
export const CategoryPageBrandOverview: FC<CategoryPageBrandOverviewProps> = ({
  cmsContent,
  seoResponse,
  categoryNavigation,
  brands,
  brandHeadlines,
}) => {
  const { isDesktop } = useDeviceType();

  return (
    <Grid container spacing={0.5} columns={5}>
      {isDesktop && categoryNavigation && categoryNavigation.length > 0 && (
        <Grid item lg={1} data-testid="categorySideNavigation">
          <Grid container spacing={1} direction="column">
            <Grid item width="100%">
              <ProductCategoryNavigationDesktop items={categoryNavigation} />
            </Grid>
          </Grid>
        </Grid>
      )}

      <Grid item lg={categoryNavigation && categoryNavigation.length > 0 ? 4 : 5}>
        {cmsContent && (
          <ErrorBoundary>
            <ContentExternal data={cmsContent} />
          </ErrorBoundary>
        )}
        <Box
          sx={{
            padding: (theme) => theme.spacing(1),
          }}
        >
          <BrandList brands={brands} brandHeadlines={brandHeadlines} />
        </Box>

        {seoResponse && <ProductListSeo data={seoResponse} />}
      </Grid>
    </Grid>
  );
};
